import { genericStrategy } from '@/validation/errorStrategies/genericStrategy.ts';
import { t } from 'i18next';
import type { ErrorStrategy } from '../types';

export const patternStrategy: ErrorStrategy = ({ instancePath, keyword, params }) => {
  let validationResult = genericStrategy({
    instancePath,
    keyword,
    params,
  });
  if (instancePath === '/dpin') {
    validationResult = {
      path: instancePath,
      message: t('Validation.DpinFormatError'),
    };
  }
  if (instancePath.includes('ConnectionString/server')) {
    validationResult = {
      path: instancePath,
      message: t('Validation.ConnectionStringServer'),
    };
  }
  if (instancePath.includes('ConnectionString/database')) {
    validationResult = {
      path: instancePath,
      message: t('Validation.ConnectionStringDatabase'),
    };
  }
  if (instancePath.includes('serialNumber')) {
    validationResult = {
      path: instancePath,
      message: t('Validation.SerialNumberFormatError'),
    };
  }
  return validationResult;
};
